import user, { UserState } from "./user";
import loginRequest, { LoginRequestState } from "./loginRequest";
import consents, { ConsentsState } from "./consents";
import purchases, { PurchaseState } from "./eventPurchases";
import i18n, { I18nState } from "./i18n";
import receipts, { ReceiptsState } from "./receipts";
import marketingConsents, { MarketingConsentsState } from "./marketingConsents";
import authWithNonce, { LoginNonceRequestState } from "./authWithNonce";

export interface ApplicationState {
  user: UserState;
  loginRequest: LoginRequestState;
  purchases: PurchaseState;
  consents: ConsentsState;
  i18n: I18nState;
  receipts: ReceiptsState;
  authWithNonce: LoginNonceRequestState;
  marketingConsents: MarketingConsentsState;
}

export default {
  user,
  marketingConsents,
  loginRequest,
  purchases,
  consents,
  i18n,
  authWithNonce,
  receipts,
};
